var React = require('react');

function UserApplicationLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 42H5a5 5 0 01-5-5V5a5 5 0 015-5h38a5 5 0 015 5v14a1 1 0 01-2 0V5a3 3 0 00-3-3H5a3 3 0 00-3 3v32a3 3 0 003 3h18a1 1 0 010 2z","key":0}),React.createElement("path",{"d":"M8 7.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM47 12H1a1 1 0 110-2h46a1 1 0 010 2zM14 7.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm6 0a1.5 1.5 0 010-3 .75.75 0 01.21 0 1.504 1.504 0 01-.21 3zM47 48H27a1 1 0 01-1-1 11 11 0 1122 0 1 1 0 01-1 1zm-18.95-2h17.89a9 9 0 00-17.89 0zM37 35a7 7 0 110-14 7 7 0 010 14zm0-12a5 5 0 100 10 5 5 0 000-10zm-13-3H14a1 1 0 110-2h10a1 1 0 010 2zm-4 9h-6a1 1 0 110-2h6a1 1 0 010 2zM8 20.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","key":1})]);
}

UserApplicationLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = UserApplicationLight;

UserApplicationLight.default = UserApplicationLight;
